module.exports = __webpack_public_path__ + "img/cosmetics_icon.6f99b948.png";